export class PurposePassTypes {
  static DISABLED = 0
  static DEFAULT_OFF = 1
  static DEFAULT_ON = 2
  static ENABLED_ALWAYS = 3
}
